import { formatDate } from "@/lib/utils";
import {
  Badge,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Text,
} from "@a7y/tailwind-catalyst";
import type { AdminOrganizationDetail } from "@a7y/types";
import { Users } from "lucide-react";
import { ROLE_COLORS } from "./constants";
import { Section } from "./shared";

export interface MembersTabProps {
  members: AdminOrganizationDetail["members"];
}

export function MembersTab({ members }: MembersTabProps) {
  return (
    <Section title={`Members (${members.length})`} icon={<Users className="h-5 w-5" />}>
      <Table className="[--gutter:--spacing(6)] sm:[--gutter:--spacing(8)]">
        <TableHead>
          <TableRow>
            <TableHeader>User</TableHeader>
            <TableHeader>Role</TableHeader>
            <TableHeader>Joined</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {members.length === 0 ? (
            <TableRow>
              <TableCell colSpan={3} className="text-center">
                <Text className="text-zinc-500">No members found</Text>
              </TableCell>
            </TableRow>
          ) : (
            members.map((member) => (
              <TableRow
                key={member.membershipId}
                href={`/admin/users/${member.userId}`}
                title={member.name || member.email || member.userId}
              >
                <TableCell>
                  <div>
                    <Text className="font-medium">{member.name || "Unknown"}</Text>
                    <Text className="text-zinc-500">{member.email || member.userId}</Text>
                  </div>
                </TableCell>
                <TableCell>
                  <Badge color={ROLE_COLORS[member.role ?? ""] ?? "zinc"}>
                    {(member.role ?? "unknown").toUpperCase()}
                  </Badge>
                </TableCell>
                <TableCell className="text-zinc-500">
                  {formatDate(member.joinedAt)}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Section>
  );
}
